export default __webpack_public_path__ + "static/media/icon-search-plus.64ef5817.svg";